import React, {useState, useEffect} from 'react';
import {BrowserRouter as Router, Route, Routes, useLocation, useNavigate} from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Features from './components/Features';
import Pricing from './components/Pricing';
import Contact from './components/Contact';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsConditions from './components/T&Cs';
import './styles/main.css';
import './styles/utilities.css';
import './styles/animations.css';
import Checkout from "./components/Checkout";
import Subprocessors from "./components/SubProcessors";
import CookiePolicy from "./components/CookiePolicy";
import MFACodeModal from "./components/MFACodeModal";
import MfaSetupHelper from "./components/MfaSetupHelper";

function App() {
    const [showPrivacy, setShowPrivacy] = useState(false);
    const [showTerms, setShowTerms] = useState(false);
    const [showCheckout, setShowCheckout] = useState(false);
    const [checkoutSuccess, setCheckoutSuccess] = useState(false);
    const [showProcessors, setShowProcessors] = useState(false);
    const [showCookies, setShowCookies] = useState(false);
    const [showMfa, setShowMfa] = useState(false);
    const [showMfaHelp, setShowMfaHelp] = useState(false);
    const [mfaVerify, setMfaVerify] = useState(false);

    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const mode = params.get('modal');
        const checkout_success = params.get('checkout-success');
        const verify = params.get('verify');

        if (mode === 'privacy') {
            setShowPrivacy(true);
        } else if (mode === 'terms') {
            setShowTerms(true);
        } else if (mode === 'checkout') {
            setShowCheckout(true);
            setCheckoutSuccess(checkout_success === "true")
        } else if (mode === 'mfa') {
            setShowMfa(true);
            setMfaVerify(verify === "true")
        } else if (mode === 'mfa-help') {
            setShowMfaHelp(true);
        } else if (mode === 'subprocessors') {
            setShowProcessors(true);
        } else if (mode === 'cookies') {
            setShowCookies(true);
        }
    }, [location]);

    useEffect(() => {
        const savedTheme = localStorage.getItem('theme');
        const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;

        if (savedTheme === 'dark' || (!savedTheme && prefersDark)) {
            document.documentElement.setAttribute('data-theme', 'dark');
        }
    }, []);

    return (
        <div className="app">
            <Navbar/>
            <Home/>
            <Routes>
                <Route exact path="/" component={Home}/>
            </Routes>
            <Footer/>
            {showPrivacy && <PrivacyPolicy onClose={() => {
                setShowPrivacy(false);
                navigate('/')
                setTimeout(() => {
                    const element = document.getElementById('pricing');
                    if (element) {
                        element.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        });
                    }
                }, 100);
            }}/>}
            {showMfaHelp && <MfaSetupHelper onClose={() => {
                setShowMfaHelp(false);
                navigate('/')
                setTimeout(() => {
                    const element = document.getElementById('pricing');
                    if (element) {
                        element.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        });
                    }
                }, 100);
            }}
            customerEmail={'the backup email you supplied to Sentryō'}/>}
            {showTerms && <TermsConditions onClose={() => {
                setShowTerms(false);
                navigate('/')
                setTimeout(() => {
                    const element = document.getElementById('pricing');
                    if (element) {
                        element.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        });
                    }
                }, 100);
            }}/>}
            {showCookies && <CookiePolicy onClose={() => {
                setShowTerms(false);
                navigate('/')
                setTimeout(() => {
                    const element = document.getElementById('features');
                    if (element) {
                        element.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        });
                    }
                }, 100);
            }}/>}
            {showMfa && <MFACodeModal isOpen={showMfa}
                                      onClose={() => {
                                          setShowMfa(false);
                                          navigate('/')
                                          setTimeout(() => {
                                              const element = document.getElementById('hero');
                                              if (element) {
                                                  element.scrollIntoView({
                                                      behavior: 'smooth',
                                                      block: 'start'
                                                  });
                                              }
                                          }, 100);
                                      }}
                                      verify={mfaVerify}/>}
            {showCheckout && <Checkout
                key={checkoutSuccess ? 'success' : 'failure'}
                onClose={(section) => {
                    setShowCheckout(false);
                    navigate('/')
                    setTimeout(() => {
                        const element = document.getElementById(section);
                        if (element) {
                            element.scrollIntoView({
                                behavior: 'smooth',
                                block: 'start'
                            });
                        }
                    }, 100);
                }}
                success={checkoutSuccess}/>}
            {showProcessors && <Subprocessors onClose={() => {
                setShowProcessors(false);
                navigate('/')
                setTimeout(() => {
                    const element = document.getElementById('features');
                    if (element) {
                        element.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        });
                    }
                }, 100);
            }}/>}
        </div>
    );
}

const Home = () => (
    <>
        <Hero/>
        <Features/>
        <Services/>
        {/*<CaseStudies />
        <Testimonials />*/}
        <Pricing/>
        <Contact/>
    </>
);

export default function Root() {
    return (
        <Router>
            <App/>
        </Router>
    );
}